/**
 * Enumeration of all pages
 */
export enum Page {
    /** Represents the CanvasComponent */
    Canvas = "canvas",
    Leaderboard = "leaderboard",
    Result = "result",
    Auth = "auth",
    TravelMap = "travel-map",
    Journal = "journal",
    Ethan = "ethan",
    DeAbt = "deAbt",
    ModalPuzzel = "modal-puzzel",
    Inventory = "inventory",
    UitlogMessage = "uitlog-message",
};
